import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NumberPlatePaymentsService } from 'src/app/services/transit/number-plate-payments.service';
import { VehiclesService } from 'src/app/services/vehicles/vehicles.service';
import { GlobalService } from 'src/app/services/shared/global.service';

@Component({
  selector: 'app-add-number-plate-pmt',
  templateUrl: './add-number-plate-pmt.component.html',
  styleUrls: ['./add-number-plate-pmt.component.css']
})
export class AddNumberPlatePmtComponent implements OnInit{
  isProcessing: boolean = false;
  public vehicle_id: string | null = null;
  public errorMessage: string | null = null;
  form!: FormGroup;
  vehicle:any;
  submitted: boolean = false;

  constructor(
    private numberPlatePaymentsService:NumberPlatePaymentsService,
    private vehiclesService:VehiclesService,
    private globalService: GlobalService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder
  ){
    this.form = this.formBuilder.group({
      invoice_no: [, Validators.required],
      src_currency: ['', Validators.required],
      amount: [, Validators.required],
    })
  }

  ngOnInit(): void {
    this.isProcessing = true;

    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.vehicle_id = param['get']('vehicle_id')
    })

    if(this.vehicle_id){
      this.getVehicleData(this.vehicle_id);
    }else{
      //Navigate back with error
      this.errorMessage="Unable to select the vehicle record to add UNBS charges!";
      this.globalService.setGlobalErrorMessage(this.errorMessage);
      this.router.navigate(['vehicles/pending-number-plate-payment']);
    }
  }

  /**
   * Get single vehicle info
   * @param vehicle_id
   */
  getVehicleData(vehicle_id: string): void {
    this.vehiclesService.editVehicle(vehicle_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.isProcessing=false;
          this.vehicle = response;

          if(this.vehicle.status==='no_data' || this.vehicle.status.length===0){
            this.errorMessage=this.vehicle.message;
          }else{
            this.isProcessing=false;
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  handleSubmit() {
    this.submitted = true;
    this.isProcessing = true;

    if (this.form.valid) {
      const postData = {
        ...this.form.value,
        vehicle_id: this.vehicle_id
      };

      this.numberPlatePaymentsService.store(postData)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isProcessing = false;
            this.globalService.setGlobalSuccessMessage(response.message);

            this.router.navigate(['vehicles/pending-number-plate-payment']);
          }else{
            this.submitted = false;
            this.isProcessing = false;
            this.errorMessage=response.message;
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing = false;
          this.errorMessage=error;
        }
      });
    }else{
      this.isProcessing = false;
    }
  }
}
